module.exports = __webpack_public_path__ + "static/media/snow-mobile.a4ceed6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/login/snow-mobile.jpg
// module id = 41
// module chunks = 0